import allfeatLogomark from "./assets/icons/allfeat-logomark.svg";

const ICONS: Record<string, string> = {
  allfeat: allfeatLogomark,
  "allfeat-melodie-3": allfeatLogomark,
};

export function icon(network: string): string {
  return ICONS[network] ?? allfeatLogomark;
}
